<template>
  <section class="section full-height">
    {{ $t('Tu plan ha caducado') }}
  </section>
</template>

<script>
export default {
  name: 'Expired',
  components: {},
  computed: {},
  data() {
    return {
      clients: [],
      isLoadingClients: false
    }
  },
  mounted() {
    this.$store.commit('layout/SUB_PAGE', {
      stack: ['Admin', 'Expired'],
      title: 'Expired'
    })
  }
}
</script>

<style scoped></style>
